var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.75C5.175 18.75 1.25 14.825 1.25 10H2.5C2.5 14.1356 5.86438 17.5 10 17.5V18.75ZM7.5 5H4.42375C5.835 3.4225 7.84062 2.5 10 2.5C14.1356 2.5 17.5 5.86438 17.5 10H18.75C18.75 5.175 14.825 1.25 10 1.25C8.83406 1.24978 7.67997 1.48392 6.60631 1.93851C5.53264 2.3931 4.5613 3.05887 3.75 3.89625V1.25H2.5V6.25H7.5V5ZM13.75 16.9875L12.1313 15.3688L11.25 16.25L13.75 18.75L18.75 13.75L17.8687 12.8688L13.75 16.9875Z",
    fill: "#C28E08",
    stroke: "#C28E08",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateComplete);
export default __webpack_public_path__ + "static/media/update-complete.5ad1b22fae777aa1eb0c6f2a592962e4.svg";
export { ForwardRef as ReactComponent };